<template>
  <d-container
    paddingless-mobile
    fluid
  >
    <v-form
      ref="form"
      :data="form"
      :url="endpoint.url"
      :method="endpoint.method"
      @success="successForm"
    >
      <d-card>
        <d-card-row>
          <h3 class="title is-6">
            {{ $t("general_info") }}
          </h3>
        </d-card-row>

        <d-card-row>
          <v-input
            v-model="form.name"
            required
            name="name"
          />
        </d-card-row>
        <d-card-row>
          <v-input
            v-model="form.email"
            required
            type="email"
            name="email"
          />
        </d-card-row>

        <d-card-row v-if="$roleCan([$laravel.role_admin])">
          <v-input
            v-model="form.password"
            name="password"
            required
            :label="passwordLabel"
            type="password"
            :password-reveal="true"
          />
        </d-card-row>

        <d-card-row>
          <v-input
            v-model="form.phone"
            name="phone"
            required
          />
        </d-card-row>

        <d-card-row>
          <v-input-select
            v-model="form.locale"
            name="locale"
          >
            <option
              v-for="(locale, code) in $laravel.app.locales"
              :key="code"
              :value="code"
            >
              {{ locale }}
            </option>
          </v-input-select>
        </d-card-row>
      </d-card>
      <d-card>
        <d-card-row>
          <h3 class="title is-6">
            {{ $t("extra_info") }}
          </h3>
        </d-card-row>
        <d-card-row>
          <v-input-switch
            v-model="form.tenant_insurance"
            :true-value="true"
            :false-value="false"
            name="tenant_insurance"
          />
        </d-card-row>

        <d-card-row>
          <v-input
            v-model="form.payment_method"
            :is-html-label="true"
            name="payment_method"
          />
        </d-card-row>

        <d-card-row>
          <v-input-tag
            v-model="form.possible_lease_duration"
            name="possible_lease_duration"
            :label="$t('possible_lease_duration').capitalize()"
            field="label"
            :data="getInputTagData(ownerPossibleLeaseDurations, 'possible_lease_duration')"
            :open-on-focus="true"
            @input="handlePossibleLeaseDurationInput"
          />

          <div
            v-if="isOwnerPossibleLeaseDurationOtherVisible"
            class="mt-4"
          >
            <v-input
              v-model="form.possible_lease_duration_other"
              name="possible_lease_duration_other"
              :placeholder="$t('other')"
            />
          </div>
        </d-card-row>


        <d-card-row>
          <v-input-rich-text
            v-model="form.important_information_for_lease_writing"
            name="important_information_for_lease_writing"
          />
        </d-card-row>
      </d-card>
      <div class="has-text-right">
        <button
          class="button is-primary"
          type="submit"
        >
          {{ $t("save") }}
        </button>
      </div>
    </v-form>
  </d-container>
</template>

<script>
import { fillFields } from "@/services/helpers";

export default {
  props: {
    action: {
      type: String,
      required: true,
    },
    model: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      form: {
        name: "",
        email: "",
        locale: this.$laravel.app.locale,
        password: "",
        phone: "",
        tenant_insurance: false,
        possible_lease_duration: [],
        possible_lease_duration_other: "",
        important_information_for_lease_writing: "",
        payment_method: "",
      },
    };
  },
  computed: {
    endpoint() {
      if (this.action === "create") {
        return {
          method: "post",
          url: this.$laravel.route("api.owners.store"),
        };
      }
      if (this.action === "edit") {
        return {
          method: "patch",
          url: this.$laravel.route("api.owners.update", {
            owner: this.model.id,
          }),
        };
      }
      return null;
    },
    passwordLabel() {
      return this.action === "create"
        ? this.$t("attributes.password").capitalize()
        : this.$t("attributes.password").capitalize() +
            " (" +
            this.$t("leave_empty_to_keep_current").capitalize() +
            ")";
    },
    ownerPossibleLeaseDurations()
    {
      const ownerPossibleLeaseDurations = window.Laravel.ownerPossibleLeaseDurations;

      if (! ownerPossibleLeaseDurations || ! ownerPossibleLeaseDurations.length) {
        return [];
      }

      return ownerPossibleLeaseDurations.map((item) => {

        return {
          "key" : item,
          "label" :  this.$t(item)
        };
      });
    },
    isOwnerPossibleLeaseDurationOtherVisible()
    {
      if (! this.form.possible_lease_duration || ! this.form.possible_lease_duration.length) {
        return false;
      }

      return this.form.possible_lease_duration.some(item => item.key === "lease_duration_other");
    },
  },
  created() {
    if (this.action === "edit") {
      this.form = fillFields(this.form, this.model);
    }
  },
  methods: {
    handlePossibleLeaseDurationInput(value) {

      if (! value || ! value.length) {
        return;
      }

      if (! value.some(item => item.key === "lease_duration_other")) {
        this.form.possible_lease_duration_other = "";
      }

    },
    getInputTagData(data, field) {

      if (! this.form[field] ) {
        return data;
      }

      return data.filter(tag => !this.form[field].some(selected => selected.key === tag.key));
    },
    successForm(event) {
      if (event.status == 200) {
        if (this.action === "edit") {
          this.$router.push("/owners/" + this.model.id);
        } else {
          this.$router.push("/owners/" + event.data.owner.id + "/contacts");
        }
      }
    },
  },
};
</script>
